import { defineMessages } from 'react-intl';

export default defineMessages({
    withdrawalAmountHeader: {
        id: '_.choose_loan_amount.withdrawal_amount_header',
        defaultMessage: 'I want to borrow {input}'
    }
});
